/**
 * Renouvellement de la session (révision du référent du 2026-10-31) : logique pure, testée
 * (apps/web/tests/unit/session-renouvellement.test.ts). Un échec réseau (sortie de veille, Wi-Fi
 * pas encore revenu) se réessaie ; seule une réponse de Keycloak disant que la session n'existe
 * plus la déclare expirée.
 */

export type SuiteEchec = 'reessayer' | 'expiree';

/** Réponses OIDC qui signifient « session terminée » (et non « réseau indisponible »). */
const FIN_DE_SESSION = new Set([
  'invalid_grant',
  'login_required',
  'interaction_required',
  'invalid_token',
  'unauthorized_client',
]);

export function apresEchecRenouvellement(erreur: unknown): SuiteEchec {
  const code =
    erreur !== null && typeof erreur === 'object' && 'error' in erreur
      ? (erreur as { error?: unknown }).error
      : undefined;
  return typeof code === 'string' && FIN_DE_SESSION.has(code) ? 'expiree' : 'reessayer';
}

/** Attente avant un nouvel essai : 5 s, 15 s, 30 s, puis chaque minute. */
export function delaiReessai(tentative: number): number {
  const paliers = [5_000, 15_000, 30_000];
  return paliers[tentative] ?? 60_000;
}

/** Renouveler maintenant ? Jeton expiré ou expirant dans la minute (retour de veille). */
export function renouvellementDu(expiresIn: number | undefined): boolean {
  return expiresIn === undefined || expiresIn < 60;
}

/**
 * Page à retrouver après la reconnexion : chemin, recherche et ancre, sans les paramètres de
 * retour de Keycloak (`code`, `state`, `session_state`, `iss`).
 */
export function cibleRetour(l: { pathname: string; search: string; hash: string }): string {
  const params = new URLSearchParams(l.search);
  for (const p of ['code', 'state', 'session_state', 'iss', 'error', 'error_description'])
    params.delete(p);
  const recherche = params.toString();
  const chemin = l.pathname.startsWith('/') ? l.pathname : `/${l.pathname}`;
  return `${chemin}${recherche === '' ? '' : `?${recherche}`}${l.hash}`;
}

/** Adresse de retour sûre (même origine, chemin absolu) ; sinon l'accueil. */
export function retourSur(state: unknown): string {
  if (typeof state !== 'string' || !state.startsWith('/') || state.startsWith('//')) return '/';
  return state;
}
